// @flow
import type { FI_AGGREGATOR } from './types';

// TODO: This should be in QCS and returned as part of an institution
//
export const getAggregatorFromInstitution = (institution) : FI_AGGREGATOR => institution.ofx ? 'FDS' : 'PLAID';

export const getTrackingIdFromInstitution = (institution) => {
  if (getAggregatorFromInstitution(institution) === 'PLAID') {
    return institution.plaid.id;
  }
  return institution.ofx.bid;
};
